import type { ExcelAction } from "./types";
import { importPdf } from "./importPdf";
import { findDataIslands } from "./findDataIslands";
import { findUniqueFormulas } from "./findUniqueFormulas";
import { findStrings } from "./findStrings";
import { findCellTypes } from "./findCellTypes";
import { traceCell } from "./traceCell";
import { listNamedRanges } from "./listNamedRanges";
import { reformat } from "./reformat";

export type { ExcelAction, ActionContext, LogLevel } from "./types";

export const actions: ExcelAction[] = [
  reformat,
  traceCell,
  findDataIslands,
  findUniqueFormulas,
  findStrings,
  findCellTypes,
  listNamedRanges,
  importPdf,
];
